import { replaceKeywords, DonMinus } from "@/components/keywords";
import { Chip } from "@heroui/react";

export default function KeywordStats({
  keywordDict,
}: {
  keywordDict: Record<string, number>;
}) {
  let display = [];
  // Blocker, Rush, 2ks, 1ks

  const sortedEntries = Object.entries(keywordDict).sort(
    ([, a], [, b]) => b - a,
  );

  for (const [k, v] of sortedEntries) {
    if (k.includes("DON!!")) {
      display.push(
        <Chip key={k} startContent={<DonMinus />} className="bg-default-100">
          {v}
        </Chip>,
      );
    } else {
      display.push(
        <Chip
          key={k}
          startContent={<div>{replaceKeywords(k, false)}</div>}
          className="bg-default-100"
        >
          <div key={k}>{v}</div>
        </Chip>,
      );
    }
  }

  return (
    <div>
      <div className="mb-2 font-semibold text-lg">Keyword Stats</div>
      <div className="flex flex-wrap gap-2">{display}</div>
      {/* <pre style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}>
        {JSON.stringify(keywordDict, null, 2)}
      </pre> */}
    </div>
  );
}
